import { t, translateText } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { useTheme } from '@repo/ui/hooks/use-theme';
import { Theme } from '@repo/ui/providers/theme-provider';
import { RadioGroup, RadioGroupItem } from '@repo/ui/radio-group';
import { CheckIcon, MinusIcon } from 'lucide-react';
import UiDark from '@/assets/appearances/ui-dark.png';
import UiLight from '@/assets/appearances/ui-light.png';
import UiSystem from '@/assets/appearances/ui-system.png';
import { SettingsHeader } from '@/components/settings-header';

const THEME_IMAGES = {
  light: UiLight,
  dark: UiDark,
  system: UiSystem,
} as const;

export const AppearancesPage = () => {
  useLocale();

  const { theme, setTheme } = useTheme();

  return (
    <div className="raven-page raven-settings">
      {/* <header className="space-y-2">
        <h2 className="font-semibold text-base">Appearance</h2>
        <p className="text-muted-foreground">
          Customize the appearance of the app. Automatically switch between day and night themes.
        </p>
      </header> */}
      <SettingsHeader
        subtitle={t('auth.customizeTheAppearanceOfTheAppAutomaticallySwitchBetween')}
        title={t('workspace.appearances')}
      />
      <div className="space-y-4">
        <RadioGroup
          className="grid grid-cols-3 gap-4"
          defaultValue={theme}
          name="theme"
          onValueChange={(value: Theme) => setTheme(value)}
          value={theme}
        >
          {Object.values(Theme).map((value) => (
            <label className="relative" htmlFor={value} key={value}>
              <RadioGroupItem className="peer sr-only" id={value} value={value} />
              <img
                alt={translateText(value.charAt(0).toUpperCase() + value.slice(1))}
                className="relative cursor-pointer overflow-hidden rounded-lg border border-input shadow-xs outline-none transition-[color,box-shadow] peer-focus-visible:ring-[3px] peer-focus-visible:ring-ring/50 peer-data-disabled:cursor-not-allowed peer-data-[state=checked]:border-ring peer-data-[state=checked]:bg-accent peer-data-disabled:opacity-50"
                height={160}
                src={
                  value in THEME_IMAGES && THEME_IMAGES[value as Theme]
                    ? THEME_IMAGES[value as Theme]
                    : UiSystem
                }
                width={220}
              />
              <span className="group mt-2 flex items-center gap-1 peer-data-[state=unchecked]:text-muted-foreground/70">
                <CheckIcon
                  aria-hidden="true"
                  className="group-peer-data-[state=unchecked]:hidden"
                  size={16}
                />
                <MinusIcon
                  aria-hidden="true"
                  className="group-peer-data-[state=checked]:hidden"
                  size={16}
                />
                <span className="font-medium text-xs">
                  {translateText(value.charAt(0).toUpperCase() + value.slice(1))}
                </span>
              </span>
            </label>
          ))}
        </RadioGroup>
      </div>
    </div>
  );
};
